import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';
import FormGroup from '../../../components/controls/FormGroup';
import InputSelect from '../../../components/controls/InputSelect';
import MuiButton from '../../../components/controls/MuiButton';
import { defaultFormProperties } from '../../../utilities/form';
import wellnessProgramPaymentResources from '../wellnessProgramPaymentsResources';
import * as validationRules from './paymentViaACHFormValidation';
import './_payment-via-ach-from.scss';

const PaymentViaACHForm = ({
    pristine,
    submitting,
    handleSubmit,
    onSubmitSend,
    onSubmitDownload,
    programTypes,
    programPaymentTypes,
    partners,
    periods,
    isSendDisabled,
    sendErrorMessage,
    paymentTypes,
    paymentTypeFilterVisible,
    programPaymentTypeFilterDisabled,
    onProgramPaymentTypeChange
}) => {
    return <FormGroup>
        {
            <>
                <Field
                    label={wellnessProgramPaymentResources.labelProgramType}
                    name="programPaymentType"
                    options={programPaymentTypes}
                    getOptionLabel={option => option.get('name')}
                    getOptionValue={option => option.get('id')}
                    component={InputSelect}
                    isDisabled={programPaymentTypeFilterDisabled}
                    onChange={onProgramPaymentTypeChange}
                />
                {paymentTypeFilterVisible ?
                    <Field
                        label={wellnessProgramPaymentResources.labelPaymentType}
                        name="paymentType"
                        options={paymentTypes}
                        getOptionLabel={option => option.get('name')}
                        getOptionValue={option => option.get('id')}
                        component={InputSelect}
                    />
                    : <></>
                }
            </>
        }
        <Field
            component={InputSelect}
            label={wellnessProgramPaymentResources.labelPartner}
            name="partner"
            options={partners}
            getOptionLabel={option => option.get('name')}
            getOptionValue={option => option.get('id')}
            validate={[validationRules.partnerRequired]}
        />
        <Field
            component={InputSelect}
            label={wellnessProgramPaymentResources.labelVisitMonth}
            name="period"
            options={periods}
            getOptionLabel={option => option.get('yearMonth')}
            getOptionValue={option => option.get('id')}
            validate={[validationRules.visitMonthRequired]}
        />
        <div className="grid__row">
            <div className="col-lg-4">
                <MuiButton
                    className="btn_new btn_new--blue"
                    name="buttonSend"
                    disabled={pristine || submitting || isSendDisabled}
                    onClick={handleSubmit(values => onSubmitSend(values))}
                >
                    {wellnessProgramPaymentResources.buttonSendToUSBank}
                </MuiButton>
            </div>
            <div className="col-lg-4">
                <MuiButton
                    className="btn_new btn_new--blue"
                    name="buttonDownload"
                    disabled={pristine || submitting}
                    onClick={handleSubmit(values => onSubmitDownload(values))}
                >
                    {wellnessProgramPaymentResources.buttonDownloadForPreview}
                </MuiButton>
            </div>
            {sendErrorMessage && (
                <div className="payment-via-ach-form__submit-validation-error">{sendErrorMessage}</div>
            )}
        </div>
    </FormGroup>;
};

PaymentViaACHForm.propTypes = {
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmitSend: PropTypes.func.isRequired,
    onSubmitDownload: PropTypes.func.isRequired,
    programTypes: PropTypes.object.isRequired,
    programPaymentTypes: PropTypes.object.isRequired,
    partners: PropTypes.object.isRequired,
    periods: PropTypes.object,
    isSendDisabled: PropTypes.bool.isRequired,
    sendErrorMessage: PropTypes.string,
    paymentTypes: PropTypes.object,
    paymentTypeFilterVisible: PropTypes.bool,
    programPaymentTypeFilterDisabled: PropTypes.bool,
    onProgramPaymentTypeChange: PropTypes.func
};

export default reduxForm({
    ...defaultFormProperties
})(PaymentViaACHForm);
